import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import "./responsive.css";
import Home from "./pages/Home/Home";
import Collections from "./pages/Collections/Collections";
import ProductPage from "./pages/ProductPage/ProductPage";
import Wishlist from "./pages/Wishlist/Wishlist";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./components/Sidebar/Sidebar";
import Login from "./pages/Login/Login";
import Cart from "./components/Cart/Cart";
import React, { useEffect } from "react";
import AdvertisementPopup from "./components/AdvertisementPopup";
import Search from "./components/Search/Search";
import { checkAuth } from "./utils/checkAuth";
import Profile from "./pages/Profile/Profile";
import LoadingAnimation from "./components/LoadingAnimation/LoadingAnimation"; // Adjust path
import AnimatedTopbar from "./components/topbar/AnimatedTopbar";
import TrackOrder from "./pages/ProductPage/TrackOrder";
import CancelOrder from "./pages/ProductPage/CancelOrder";
import ContactUs from "./pages/Others/ContactUs";
import AboutUs from "./pages/Others/AboutUs";
import FAQs from "./pages/Others/FAQs";
import PrivacyPolicy from "./pages/Others/PrivacyPolicy";
import TermsConditions from "./pages/Others/TermsConditions";
import RefundReturn from "./pages/Others/RefundReturn";
import ShippingInfo from "./pages/Others/ShippingInfo";
import SuccessPage from "./pages/Others/SuccessPage";
import FailurePage from "./pages/Others/FailurePage";

function App() {
  const [cartOpen, setCartOpen] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  const isLogin = useSelector((state) => state.appstate.isLogin);
  const user = useSelector((state) => state.appstate.user);

  return (
    <Router>
      <div className="App">
        <LoadingAnimation /> {/* Place it here, outside specific routes */}
        <AdvertisementPopup /> {/* overlay popup, not bound to header */}
        <header className="App-header">
          <AnimatedTopbar />
          <div className="buttons-bar">
            <Link to="/track-order" className="link">
              Track Order
            </Link>
            <Link to="/cancel-order" className="link">
              Cancel Order
            </Link>
          </div>
          <Navbar onCartClick={() => setCartOpen(true)} />
          <Sidebar />
          <Search />
          {cartOpen && <Cart onClose={() => setCartOpen(false)} />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections/:slug" element={<Collections />} />
            <Route path="/products/:slug" element={<ProductPage />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/login" element={<Login />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/cancel-order" element={<CancelOrder />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/refund-return" element={<RefundReturn />} />
            <Route path="/shipping" element={<ShippingInfo />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/failure" element={<FailurePage />} />
          </Routes>
          <Footer />
        </header>
      </div>
    </Router>
  );
}

export default App;
